/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityExpertDto } from '../../models/security-expert-dto';

export interface GetSvgInfoAdminSecurityExperts$Params {

/**
 * Svg number of the svg infos
 */
  svg?: string;
}

export function getSvgInfoAdminSecurityExperts(http: HttpClient, rootUrl: string, params?: GetSvgInfoAdminSecurityExperts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityExpertDto>>> {
  const rb = new RequestBuilder(rootUrl, getSvgInfoAdminSecurityExperts.PATH, 'get');
  if (params) {
    rb.query('svg', params.svg, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SecurityExpertDto>>;
    })
  );
}

getSvgInfoAdminSecurityExperts.PATH = '/svg-info-admin/security-experts';
